<template>
  <div class="page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/index' }">数据概览</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/index' }">应用中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/index' }">网上展览</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/exhibition/list' }">展览管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{exhibitionTitle}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/exhibition/content/' + this.$route.params.m_id }">内容设置</el-breadcrumb-item>
      <el-breadcrumb-item>资讯管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-content">
      <div class="menu-area">
        <el-button type="primary" @click="toAdd">添加资讯</el-button>
      </div>
      <el-table :data="dataList" border style="width: 100%" max-height="500">
        <el-table-column prop="id" label="#" width="80"></el-table-column>
        <el-table-column prop="title" label="资讯名称"></el-table-column>
        <el-table-column prop="thumbnail" label="资讯缩略图" width="120">
          <template slot-scope="scope">
            <el-image class="banner-img" fit="fill" :src="scope.row.thumbnail" :preview-src-list="[scope.row.thumbnail]" lazy></el-image>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="330">
          <template slot-scope="scope">
            <el-button size="small" type="success" @click="editItem(scope.row.m_id)">编辑</el-button>
            <el-button type="danger" size="small" @click="delItem(scope.row.m_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      dataList: [],
      exhibitionTitle: ''
    }
  },
  created () {
    this.getPageData()
  },
  methods: {
    async getPageData () {
      const { data: res } = await this.$http.get('/exhibition-info-list', { params: { m_id: this.$route.params.m_id } })
      if (res.status === 200) {
        this.dataList = res.data.list
        this.exhibitionTitle = window.sessionStorage.getItem('ex_name')
      } else {
        this.$message.error(res.msg)
      }
    },
    editItem (mid) {
      this.$router.push('/admin/apps/exhibition/content/' + this.$route.params.m_id + '/info/edit/' + mid)
    },
    async delItem (mid) {
      const { data: res } = await this.$http.delete('/exhibition-info/', { params: { m_id: mid } })
      if (res.status === 200) {
        this.$message.success(res.msg)
        await this.getPageData()
      } else {
        this.$message.error(res.msg)
      }
    },
    toAdd () {
      this.$router.push('/admin/apps/exhibition/content/' + this.$route.params.m_id + '/info/add')
    }
  }
}
</script>

<style scoped>
.menu-area{
  padding: 0 0 20px 0;
  text-align: right;
}
.banner-img{
  max-width: 50px;
  max-height: 50px;
}
</style>
